module.exports = __webpack_public_path__ + "static/media/om_hairstyle_combover_front_shadow.04d856c5.png";